export const POLL_TIME = 55;

export enum Theme {
  morrowHill = "morrow-hill",
}
